export const ACHIEVEMENT_TRANSLATIONS_TH = {
  "never-empty-handed": {
    "name": "Never Empty-Handed",
    "description": "งานอดิเรกตกปลาถึงระดับ 10",
    "titleGained": "Skilled Angler",
  },
  "mystic-fisher": {
    "name": "Mystic Fisher",
    "description": "เปิดใช้งานช่วงซ่อนเร้นของกิจกรรมตกปลารวม 10 ครั้ง",
    "titleGained": "Fisher",
  },
  "shoals-blessing": {
    "name": "Shoal's Blessing",
    "description": "ใช้งาน Shoals ทั้งหมด 100 จุดในช่วงกิจกรรมตกปลา",
    "titleGained": "Blessing",
  },
  "strong-sailor": {
    "name": "Strong Sailor",
    "description": "จับปลาได้มากกว่า 100 กก. 2 ครั้งติดต่อกัน",
    "titleGained": "Fishing Line",
  },
  "twin-fish-fortune": {
    "name": "Twin Fish Fortune",
    "description": "จับปลา 5 ดาว 2 ตัวภายใน 1 นาที",
    "titleGained": "Osprey",
  },
  "fishing-machine": {
    "name": "Fishing Machine",
    "description": "จับปลาได้ทั้งหมด 50 ตัว ตัวละ 100 กิโลกรัม",
    "titleGained": "Fish Basket",
  },
  "shark-frenzy": {
    "name": "Shark Frenzy",
    "description": "จับฉลาม 3 ตัวจากเงาปลาสีทองในกิจกรรมตกปลาทะเลครั้งเดียว",
    "titleGained": "Shark Cage",
  },
  "shoal-caller": {
    "name": "Shoal Caller",
    "description": "ใช้งาน 3 Shoals ในกิจกรรมตกปลาครั้งเดียว",
    "titleGained": "Shoal Caller",
  },
  "starlight-fisher": {
    "name": "Starlight Fisher",
    "description": "จับปลาระดับ 5 ดาว 4 ตัวในกิจกรรมตกปลาครั้งเดียว",
    "titleGained": "Fishing Maniac",
  },
  "town-cooking-legend": {
    "name": "Town Cooking Legend",
    "description": "งานอดิเรกทำอาหารถึงเลเวล 10.",
    "titleGained": "Chef",
  },
  "fast-and-flawless": {
    "name": "Fast & Flawless",
    "description": "ปรุงอาหารระดับ 5 ดาว 2 จานภายใน 60 วินาที",
    "titleGained": "Kitchen Clock",
  },
  "green-touch": {
    "name": "Green Touch",
    "description": "งานอดิเรกทำสวนถึงเลเวลแล้ว 10.",
    "titleGained": "Horticulturist",
  },
  "plentiful-harvest": {
    "name": "Plentiful Harvest",
    "description": "เก็บเกี่ยวพืชผลระดับ 5 ดาวขณะที่ Bonus Harvest ทำงานอยู่",
    "titleGained": "Harvest",
  },
  "rainbow-luck": {
    "name": "Rainbow Luck",
    "description": "ใช้งาน Rainbow Hybrid Blessings 2 อันในการรดน้ำหลายพื้นที่เดียว",
    "titleGained": "Rainbow Luck",
  },
  "ace-cat-servant": {
    "name": "Ace Cat Servant",
    "description": "Cat Caring Hobby ถึงเลเวลแล้ว 10.",
    "titleGained": "Cat Lover",
  },
  "meow-meow-canteen": {
    "name": "Meow-Meow Canteen",
    "description": "ให้อาหารแมวโปรด 5 ตัว",
    "titleGained": "Cat Food",
  },
  "ace-dog-trainer": {
    "name": "Ace Dog Trainer",
    "description": "งานอดิเรกการดูแลสุนัขถึงระดับ 10.",
    "titleGained": "Dog Pal",
  },
  "doggie-canteen": {
    "name": "Doggie Canteen",
    "description": "ให้อาหารสุนัข 3 ตัวที่พวกเขาชื่นชอบ",
    "titleGained": "Dog Food",
  },
  "insect-commander": {
    "name": "Insect Commander",
    "description": "งานอดิเรกจับแมลงถึงระดับ 10.",
    "titleGained": "Insect Master",
  },
  "mystic-tracker": {
    "name": "Mystic Tracker",
    "description": "เปิดใช้งานเฟสที่ซ่อนอยู่ในกิจกรรมจับแมลงรวม 10 ครั้ง",
    "titleGained": "Exploration",
  },
  "swarm-commander": {
    "name": "Swarm Commander",
    "description": "กระตุ้น 100 Swarms inb ในระหว่างกิจกรรมจับแมลง",
    "titleGained": "Swarm",
  },
  "insect-harvester": {
    "name": "Insect Harvester",
    "description": "จับแมลง 3 ตัวด้วยฟองจับแมลงเพียงฟองเดียว",
    "titleGained": "Triple Catch",
  },
  "five-insects-blessing": {
    "name": "Five Insects Blessing",
    "description": "จับแมลงระดับ 5 ดาว 5 ตัวในกิจกรรมจับแมลงครั้งเดียว",
    "titleGained": "Insect Lord",
  },
  "human-insect-attractor": {
    "name": "Human Insect Attractor",
    "description": "เรียกใช้ฝูง 4 ตัวในกิจกรรมจับแมลงครั้งเดียว",
    "titleGained": "Insect Attractor",
  },
  "bird-whisperer": {
    "name": "Bird Whisperer",
    "description": "งานอดิเรกดูนกถึงเลเวล 10.",
    "titleGained": "Bird Whisperer",
  },
  "cloud-walker": {
    "name": "Cloud Walker",
    "description": "เปิดใช้งานเฟสที่ซ่อนอยู่ของกิจกรรมดูนกรวม 10 ครั้ง",
    "titleGained": "Sky",
  },
  "harmony-with-breeze": {
    "name": "Harmony with Breeze",
    "description": "กระตุ้นคลื่นนกทั้งหมด 100 คลื่นระหว่างกิจกรรมดูนก",
    "titleGained": "Resonance",
  },
  "joyful-chorus": {
    "name": "Joyful Chorus",
    "description": "กระตุ้นนก 3 คลื่นในกิจกรรมดูนกครั้งเดียว",
    "titleGained": "Feather",
  },
  "decisive-moment": {
    "name": "Decisive Moment",
    "description": "รับการ์ดข้อมูล 5 ดาว 10 ใบในกิจกรรมดูนกครั้งเดียว",
    "titleGained": "Moment",
  },
  "sand-sculpture-artist": {
    "name": "Sand Sculpture Artist",
    "description": "งานอดิเรกแกะสลักทรายถึงระดับ 5.",
    "titleGained": "Sand Sculptor",
  },
  "pumpkinarchy": {
    "name": "Pumpkinarchy",
    "description": "งานอดิเรกแกะสลักฟักทองถึงระดับ 5.",
    "titleGained": "Pumpkin Head",
  },
  "snow-king": {
    "name": "Snow King",
    "description": "งานอดิเรกแกะสลักหิมะถึงเลเวลแล้ว 5.",
    "titleGained": "Snow King",
  },
  "collector": {
    "name": "Collector",
    "description": "มาเป็นผู้เชี่ยวชาญ Collector",
    "titleGained": "Collector",
  },
  "rocket-sponsor": {
    "name": "Rocket Sponsor",
    "description": "รับรวม 500,000 Gold จากการขายสินค้าให้กับ Gold Merchant Albert Jr.",
    "titleGained": "Rocket",
  },
  "dg-member": {
    "name": "D.G. Member",
    "description": "ระดับ D.G. Member ถึงระดับ 30.",
    "titleGained": "D.G. Member",
  },
  "puzzle-artist": {
    "name": "Puzzle Artist",
    "description": "มาเป็นศิลปินปริศนา",
    "titleGained": "Puzzle",
  },
  "persistent-quill": {
    "name": "Persistent Quill",
    "description": "การเขียนความฝันถึงอาจารย์",
    "titleGained": "Writing",
  },
  "golden-music-cd": {
    "name": "Golden Music CD",
    "description": "Music Dream เข้าถึงซีดีเพลง Golden แล้ว",
    "titleGained": "Music",
  },
  "animal-neighbour": {
    "name": "Animal Neighbour",
    "description": "เข้าถึงระดับพันธบัตร 10 ด้วยกลุ่มสัตว์ 8 กลุ่ม",
    "titleGained": "New Neighbour",
  },
  "stardust-collector": {
    "name": "Stardust Collector",
    "description": "รวบรวม Starfall Shard จำนวน 60 อัน",
    "titleGained": "Star Picker",
  },
  "animal-keeper": {
    "name": "Animal Keeper",
    "description": "ค้นพบอาหารโปรดของสัตว์ทั้ง 8 หมู่",
    "titleGained": "Delicious",
  },
  "ice-elf": {
    "name": "Ice Elf",
    "description": "สเก็ตลีลาฝันถึงไอซ์เอลฟ์",
    "titleGained": "Ice Skating",
  },
  "mystery-onsen-buddy": {
    "name": "Onsen Buddy",
    "description": "เข้าออนเซ็นกับเพื่อน",
  },
  "mystery-friendship-under-the-meteor": {
    "name": "Friendship Under the Meteor",
    "description": "ที่มิตรภาพ Lv. 5 ใช้อิโมติคอน Wish กับเพื่อนในช่วงฝนดาวตก",
  },
  "mystery-super-star": {
    "name": "Super Star",
    "description": "รับ 100 ไลค์ในบ้านของคุณ",
  },
  "mystery-repair-expert": {
    "name": "Repair Expert",
    "description": "แบ่งปันชุดซ่อม 100 ชุด",
  },
  "mystery-food-diplomat": {
    "name": "Food Diplomat",
    "description": "แบ่งปันอาหาร 100 ครั้ง",
  },
  "mystery-wholesaler-of-grasslands": {
    "name": "Wholesaler of Grasslands",
    "description": "แบ่งปันพุ่มไม้พราง 100 ครั้ง",
  },
  "mystery-insect-hunting-party": {
    "name": "Insect Hunting Party",
    "description": "แบ่งปันเครื่องดูดแมลงพอง 100 ครั้ง",
  },
  "mystery-rainbow-volunteer": {
    "name": "Rainbow Volunteer",
    "description": "แบ่งปันช่อดอกไม้สายรุ้ง 50 ครั้ง",
  },
  "onsen-buddy": {
    "name": "Onsen Buddy",
    "description": "แช่ออนเซ็นกับเพื่อนฝูง",
    "titleGained": "Onsen",
    "hint": "ยอมรับไอน้ำที่หมุนวน มิตรภาพลึกซึ้งอย่างเงียบ ๆ",
  },
  "mystery-best-selling-author": {
    "name": "Best Selling Author",
    "description": "ขายหนังสือทั้งหมด 1,000 เล่ม",
  },
  "mystery-great-author": {
    "name": "Great Author",
    "description": "เขียนหนังสืออย่างน้อย 10 เล่ม แต่ละเล่มมียอดขาย 200 เล่ม",
  },
  "mystery-bookcase-full": {
    "name": "Bookcase Full (Unconfirmed)",
    "description": "ยังไม่ยืนยัน: คำใบ้บอกว่าตู้หนังสือของคุณเต็มแล้ว",
  },
  "mystery-sea-fishing-grand-slam": {
    "name": "Sea Fishing Grand Slam",
    "description": "รวบรวมชื่อสิ้นสุดกิจกรรมทั้งหมดจากกิจกรรมรายวัน Sea Fishing",
  },
  "mystery-onsen-mountain-insect-hunter": {
    "name": "Onsen Mountain Insect Hunter",
    "description": "รวบรวมชื่อตอนท้ายกิจกรรมทั้งหมดจากกิจกรรมรายวัน Bait the Insects",
  },
} as const;
